import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputGroup,
  Link,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import React from 'react'

const FieldWrapper = ({
  children,
  label,
  name,
  isRow = false,
  labelWidth = 30,
  link = '',
  error,
  leadingIcon,
  trailingIcon,
  isRequired = true,
  helperText = '',
  tooltip = '',
  ...rest
}) => {
  return (
    <FormControl
      isInvalid={error !== undefined}
      {...rest}
      as={Flex}
      direction={isRow ? 'row' : 'column'}
      justifyContent={'space-between'}
      alignItems={'center'}
      h={'100%'}
    >
      {label && (
        <FormLabel htmlFor={name} w={isRow ? `${labelWidth}%` : '100%'} color={'black'} fontWeight={'semibold'}>
          <Flex gap={1}>
            {link === '' && <Box>{label} </Box>}
            {link !== '' && (
              <Link href={link} textDecor={'underline'} color="blue.400" target={'_blank'}>
                {label}
              </Link>
            )}

            {isRequired && <Text color="red">*</Text>}
          </Flex>
        </FormLabel>
      )}
      <Flex direction={'column'} w={isRow ? `${100 - labelWidth}%` : '100%'}>
        <Tooltip label={tooltip} maxW="1000px">
          <InputGroup>
            {leadingIcon && leadingIcon}
            {children}
            {trailingIcon && trailingIcon}
          </InputGroup>
        </Tooltip>
        {error?.message && error?.message !== '' && <FormErrorMessage>{error.message}</FormErrorMessage>}

        {helperText !== '' && <FormHelperText>{helperText}</FormHelperText>}
      </Flex>
    </FormControl>
  )
}

export default FieldWrapper
